<template>
    <div class="py-4 container-fluid">
        <div class=" row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <span class="section-title">Historial de trabajos realizados</span>
                        <!-- Buscador y filtros por fecha en la misma línea -->
                        <div class="row align-items-end">
                            <div class="col-md-4 mb-3">
                                <label for="searchQuery" class="mb-1">Buscar</label>
                                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                                    placeholder="Buscar producción..." @input="fetchData(null)" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="dateStart" class="mb-1">Fecha inicio</label>
                                <input type="date" v-model="dateStart" id="dateStart" class="form-control"
                                    @change="fetchData(null)" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="dateEnd" class="mb-1">Fecha fin</label>
                                <input type="date" v-model="dateEnd" id="dateEnd" class="form-control"
                                    @change="fetchData(null)" />
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="table-responsive p-0">

                            <table class="table align-items-center mb-0 table-historial">
                                <thead>
                                    <tr>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Fecha</th>
                                        <th
                                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Producción</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Oficio</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="value in data" :key="value.id">

                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">
                                                {{ isValidDate(value.received_date)
                                                    ? new Date(value.received_date).toLocaleDateString('es-ES')
                                                    : 'Sin asignar'
                                                }}
                                            </h6>
                                        </td>

                                        <td class="align-middle text-start text-sm">
                                            <h6 class="mb-0 text-sm">
                                                {{ formatProductionLabel(value) }}
                                            </h6>
                                        </td>

                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{ value.oficio?.name || "Full" }}</h6>
                                        </td>
                                    </tr>

                                    <tr v-if="data.length === 0">
                                        <td colspan="3" class="text-center text-xxs">No hay registros disponibles</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="pagination p-3">
                                <!-- Recorremos los links para generar los botones -->
                                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                                    @click="fetchData(link.url)" :disabled="!link.url || link.active"
                                    :class="{ 'active': link.label === currentPage.toString() }">
                                    {{ link.label }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ProjectsList',
    props: ['userId'],
    data() {
        return {
            searchQuery: '',
            dateStart: '',
            dateEnd: '',
        };
    },
    computed: {
        ...mapGetters('productionUsers', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
        currentPage() {
            return this.$store.state.productionUsers.currentPage; // Obtiene la pagina actual
        },
        lastPage() {
            return this.$store.state.productionUsers.lastPage; // Obtiene la última página
        },
        data() {
            return this.allData; // Retorna los empleados desde el store
        },
        links() {
            return this.$store.getters['productionUsers/links']; // Retorna los links
        },
    },
    methods: {
        async fetchData(pageUrl = null) {
            const params = {
                user_id: this.userId,
                page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
            };
            if (this.searchQuery) params.search = this.searchQuery;
            if (this.dateStart) params.date_start = this.dateStart;
            if (this.dateEnd) params.date_end = this.dateEnd;
            await this.$store.dispatch('productionUsers/fetchData', params);
        },
        isValidDate(date) {
            if (!date) {
                return false;
            }
            const parsedDate = new Date(date);
            return !isNaN(parsedDate.getTime());
        },
        formatProductionLabel(value) {
            if (!value) return 'Sin nombre';

            // ID a mostrar: si hay producción, ese; si no, el propio id del registro
            const id =
                value.production?.id ??
                value.production_id ??
                value.id;

            // Si viene de horno (tiene production_oven_id o productionOven), mostrar Horno
            const ovenRelation = value.productionOven || value.production_oven;
            if (value.production_oven_id || ovenRelation) {
                const hornoName = ovenRelation?.oven?.name || 'Horno sin nombre';
                return `${id} - Horno: ${hornoName}`;
            }

            // Caso normal: producción de extrusión/secado
            const modelName =
                value.production?.model?.name ??
                value.model?.model?.name ??
                'Sin nombre';

            return `${id} - ${modelName}`;
        },
    },
    mounted() {
        this.fetchData(); // Llama a fetchUsers cuando el componente se monta
    },
};
</script>

<style scoped>
.table-historial {
    table-layout: fixed;
    width: 100%;
}
.table-historial th,
.table-historial td {
    width: 25%;
    padding: 0.75rem 0.5rem;
    text-align: center;
    vertical-align: middle;
}
.section-title {
    font-weight: 800;
    color: #1f2d5a;
    letter-spacing: 0.6px;
}

.section-title::after {
    content: "";
    display: block;
    width: 44px;
    height: 3px;
    margin-top: 6px;
    border-radius: 999px;
    background: #f6a500;
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.page-item {
    margin: 0 5px;
}

.active {
    font-weight: bold;
}
</style>